// ─────────────────────────────────────────────────────────────
// LACRIME DI COCCODRILLO — Contenuti modificabili
// Tutto ciò che il brand può voler cambiare vive qui:
// fragranze, domande, pesi, testi dei risultati, note olfattive,
// immagini, testi privacy. Per aggiungere una fragranza:
// 1) aggiungi una voce in FRAGRANCES
// 2) aggiungi opzioni che puntano al suo id nelle domande
// ─────────────────────────────────────────────────────────────

export const BRAND = {
  name: "Lacrime di Coccodrillo",
  payoff: "Non tutto ciò che cerchi è cibo.",
  introLead: "A volte mangiamo perché abbiamo fame.\nAltre volte cerchiamo qualcos’altro.",
  introBody:
    "Rispondi a poche domande e scopri quale delle nostre tre fragranze è più vicina a quello che stai vivendo in questo momento.",
  startLabel: "INIZIA",
  heroImage: "/assets/hero-albero.jpg",
  marquee: "Lacrime di Coccodrillo — Non tutto ciò che cerchi è cibo — ",
};

export const FRAGRANCES = [
  {
    id: "quattrotredue",
    name: "QuattroTreDue",
    resultText: [
      "Dalle tue risposte emerge soprattutto il bisogno di interrompere il sovraccarico e ritrovare un po’ di spazio.",
      "QuattroTreDue nasce per accompagnare quei momenti in cui la mente continua a correre e il cibo rischia di diventare una pausa automatica.",
    ],
    notes: "Menta, pompelmo, vetiver e geranio.",
    productUrl: "https://lacrimedicoccodrillo.shop",
    image: "/assets/frag-quattrotredue.jpg",
  },
  {
    id: "tempo",
    name: "TEMPO.",
    resultText: [
      "Dalle tue risposte sembra emergere soprattutto il bisogno di lasciar scendere la tensione dopo qualcosa che ti ha contrariato, deluso o bloccato.",
      "TEMPO. nasce per quei momenti in cui continuiamo a ripensare a quello che è successo e cerchiamo nel cibo una piccola compensazione.",
    ],
    notes: "Pompelmo, osmanto, patchouli e vaniglia.",
    productUrl: "https://lacrimedicoccodrillo.shop",
    image: "/assets/frag-tempo.jpg",
  },
  {
    id: "attimi",
    name: "Attimi di Dimenticanza",
    resultText: [
      "Dalle tue risposte sembra che in questo momento tu stia cercando soprattutto leggerezza.",
      "Ci sono giorni in cui il cibo diventa un piccolo conforto, qualcosa che proviamo a usare per cambiare, anche solo per qualche minuto, il modo in cui ci sentiamo.",
      "Attimi di Dimenticanza nasce da qui.",
    ],
    notes: "Agrumi, neroli, lavanda e sandalo.",
    productUrl: "https://lacrimedicoccodrillo.shop",
    image: "/assets/frag-attimi.jpg",
  },
];

// Pesi: Q1=2 · Q2=2 · Q3=1,5 · Q4=1,5 · Q5=1 · Q6=1 · Q7=1
// Le lettere A/B/C sono intenzionalmente mescolate tra le domande:
// non corrispondono sempre alla stessa fragranza. NON randomizzare:
// l'ordine fisso rende i dati confrontabili nel tempo.
export const QUESTIONS = [
  {
    id: 1,
    weight: 2,
    text: "Quando ti capita di cercare qualcosa da mangiare senza avere davvero fame, quale situazione riconosci più facilmente?",
    options: [
      { letter: "A", text: "Qualcosa non è andato come speravo e continuo a tornarci con la testa.", fragrance: "tempo" },
      { letter: "B", text: "Ho troppe cose insieme e sento il bisogno di interrompere tutto per un momento.", fragrance: "quattrotredue" },
      { letter: "C", text: "È una di quelle giornate in cui cerco qualcosa che mi faccia sentire un po’ meglio.", fragrance: "attimi" },
    ],
  },
  {
    id: 2,
    weight: 2,
    text: "In quel momento, cosa succede più facilmente?",
    options: [
      { letter: "A", text: "Cerco qualcosa che cambi per un attimo il tono della giornata.", fragrance: "attimi" },
      { letter: "B", text: "Faccio fatica a lasciar perdere quello che è successo.", fragrance: "tempo" },
      { letter: "C", text: "Passo rapidamente da una cosa all’altra e faccio fatica a fermarmi.", fragrance: "quattrotredue" },
    ],
  },
  {
    id: 3,
    weight: 1.5,
    text: "Se porti l’attenzione al corpo, quale sensazione riconosci più facilmente?",
    options: [
      { letter: "A", text: "Una certa pesantezza, come se avessi meno slancio del solito.", fragrance: "attimi" },
      { letter: "B", text: "Tensione: mi accorgo di essere ancora ‘accesa’.", fragrance: "quattrotredue" },
      { letter: "C", text: "Un’irrequietezza che rimane anche quando quello che è successo è finito.", fragrance: "tempo" },
    ],
  },
  {
    id: 4,
    weight: 1.5,
    text: "Quale di queste situazioni ti somiglia di più?",
    options: [
      { letter: "A", text: "La giornata continua, ma qualcosa che è successo mi rimane addosso.", fragrance: "tempo" },
      { letter: "B", text: "Avrei voglia di qualcosa di piacevole che spezzi per un momento quello che sento.", fragrance: "attimi" },
      { letter: "C", text: "Anche quando potrei fermarmi, la mia testa continua ad andare.", fragrance: "quattrotredue" },
    ],
  },
  {
    id: 5,
    weight: 1,
    text: "Immagina di avere davanti a te dieci minuti completamente liberi. Quale possibilità ti attira di più?",
    options: [
      { letter: "A", text: "Stare senza richieste, rumore o cose da fare.", fragrance: "quattrotredue" },
      { letter: "B", text: "Fare qualcosa di piacevole che mi cambi un po’ l’umore.", fragrance: "attimi" },
      { letter: "C", text: "Lasciare sedimentare quello che è successo finché perde importanza.", fragrance: "tempo" },
    ],
  },
  {
    id: 6,
    weight: 1,
    visual: true,
    text: "Senza pensarci troppo, in quale di questi luoghi entreresti adesso?",
    options: [
      {
        letter: "A",
        text: "Una piccola baia al crepuscolo, rocce accese da una luce calda.",
        fragrance: "tempo",
        image: "/assets/q6-tempo.jpg",
      },
      {
        letter: "B",
        text: "Un sentiero chiaro nell’erba alta, con l’aria che si muove.",
        fragrance: "attimi",
        image: "/assets/q6-attimi.jpg",
      },
      {
        letter: "C",
        text: "Un grande lago fermo, montagne lontane, spazio aperto.",
        fragrance: "quattrotredue",
        image: "/assets/q6-quattrotredue.jpg",
      },
    ],
  },
  {
    id: 7,
    weight: 1,
    text: "E adesso scegli d’istinto una sola parola.",
    options: [
      { letter: "A", text: "Leggerezza.", fragrance: "attimi" },
      { letter: "B", text: "Equilibrio.", fragrance: "quattrotredue" },
      { letter: "C", text: "Calma.", fragrance: "tempo" },
    ],
  },
];

// Spareggio: prima la domanda 1, poi la 2, poi la 3 (mai la 7)
export const TIEBREAK_QUESTIONS = [1, 2, 3];

export function computeResult(answers) {
  const scores = Object.fromEntries(FRAGRANCES.map((f) => [f.id, 0]));
  const byQuestion = {};
  for (const q of QUESTIONS) {
    const opt = q.options.find((o) => o.letter === answers[String(q.id)]);
    if (opt) {
      scores[opt.fragrance] += q.weight;
      byQuestion[q.id] = opt.fragrance;
    }
  }
  const max = Math.max(...Object.values(scores));
  const tied = FRAGRANCES.map((f) => f.id).filter((id) => scores[id] === max);
  if (tied.length === 1) return { id: tied[0], scores };
  for (const qid of TIEBREAK_QUESTIONS) {
    const f = byQuestion[qid];
    if (f && tied.includes(f)) return { id: f, scores };
  }
  return { id: tied[0], scores };
}

// ── Testi privacy (modificabili dal proprietario) ──────────────

export const PRIVACY_NOTICE =
  "Le tue risposte sono raccolte in forma anonima e servono solo a mostrarti il risultato e a statistiche aggregate. Non ti chiediamo nome, contatti o altri dati identificativi, e non usiamo cookie di marketing.";

// ── Sezione email dopo il risultato (facoltativa) ──────────────
// Testo del consenso marketing DEFINITIVO (14 settembre 2026) — la stessa
// versione è registrata dal backend (CONSENT_VERSION in server.py).
export const LEAD = {
  title: "Vuoi portare con te il tuo risultato?",
  body: "Lasciaci la tua email per ricevere il profilo della fragranza che hai appena scoperto.",
  namePlaceholder: "Nome (facoltativo)",
  emailPlaceholder: "La tua email",
  submitLabel: "INVIAMI IL MIO RISULTATO",
  skipLabel: "Continua senza lasciare la tua email",
  consentLabel:
    "Desidero ricevere via email novità, eventi, esperienze e comunicazioni promozionali di Lacrime di Coccodrillo. Posso revocare il consenso in qualsiasi momento.",
  consentVersion: "consenso-1.0-2026-09-14",
  successTitle: "Il tuo risultato è in viaggio.",
  successBody: "Controlla la tua casella email: ti abbiamo inviato il profilo della tua fragranza.",
  successBodyNoSend: "La tua richiesta è registrata: ti scriveremo presto.",
  dismissedLine: "Va bene così. Buon ascolto.",
};

export const PRIVACY_UPDATED = "Ultimo aggiornamento: 14 settembre 2026";

export const PRIVACY_INTRO =
  "La presente informativa descrive il trattamento dei dati personali effettuato nell’ambito dell’esperienza digitale “Profumo-Istante” di Lacrime di Coccodrillo, ai sensi del Regolamento (UE) 2016/679 (“GDPR”) e della normativa italiana applicabile in materia di protezione dei dati personali.";

export const PRIVACY_SECTIONS = [
  {
    title: "Titolare del trattamento",
    body: "Il Titolare del trattamento è:\nCALLEGARI SRL SOCIETÀ BENEFIT\nVia Pietro Giordani 15\n29121 Piacenza (PC), Italia\nP. IVA / C.F. 01917880336\nE-mail: ldc.lacrimedicoccodrillo@gmail.com\nPEC: callegarildc@pec.it",
  },
  {
    title: "Cos’è Profumo-Istante",
    body: "Profumo-Istante è un’esperienza digitale attraverso la quale l’utente risponde a sette domande e riceve l’indicazione della fragranza Lacrime di Coccodrillo più vicina alle risposte fornite in quel momento.\nL’esperienza ha finalità orientativa, esperienziale e olfattiva.\nNon costituisce un test medico, psicologico, diagnostico o nutrizionale e non fornisce diagnosi, indicazioni terapeutiche o valutazioni dello stato di salute.\nIl risultato viene determinato attraverso regole di calcolo predefinite all’interno dell’applicazione. Le risposte al questionario non vengono inviate a modelli di intelligenza artificiale per l’elaborazione del risultato.",
  },
  {
    title: "Quali dati trattiamo",
    body: "Dati relativi al questionario\nDurante l’esperienza possono essere registrati:\n— un identificativo casuale della sessione;\n— data e ora della sessione;\n— provenienza dell’accesso o della campagna, ad esempio evento, QR code, social network, packaging o punto vendita;\n— risposte fornite alle sette domande;\n— punteggi interni utilizzati dall’algoritmo;\n— fragranza risultante;\n— completamento o mancato completamento del questionario.\nPer completare il questionario e visualizzare il risultato non è necessario fornire nome, email o creare un account.\nI dati del questionario sono mantenuti separati dalla banca dati utilizzata per i contatti.\n\nDati forniti facoltativamente dall’utente\nDopo aver visualizzato il risultato, l’utente può scegliere di fornire:\n— nome, se richiesto e indicato come facoltativo;\n— indirizzo email;\n— eventuale consenso alla ricezione di comunicazioni promozionali.\nLa comunicazione dell’indirizzo email è facoltativa e non condiziona la possibilità di completare il questionario o visualizzarne il risultato.",
  },
  {
    title: "Perché trattiamo i dati",
    body: "Elaborazione e funzionamento dell’esperienza\nLe risposte vengono utilizzate per calcolare e mostrare la fragranza associata al risultato dell’esperienza e per garantire il corretto funzionamento dell’applicazione.\n\nAnalisi statistica e miglioramento dell’esperienza\nI dati relativi alle sessioni possono essere utilizzati per produrre statistiche aggregate, comprendere l’utilizzo dell’esperienza, confrontare i canali di provenienza e migliorare il questionario e il progetto Lacrime di Coccodrillo.\nLe risposte e i relativi punteggi non vengono utilizzati per creare un profilo nominativo relativo allo stato psicologico, emotivo o di salute dell’utente.\n\nInvio del risultato tramite email\nSe l’utente lo richiede espressamente, l’indirizzo email viene utilizzato per inviare il risultato dell’esperienza e le informazioni relative alla fragranza individuata.\nLa richiesta di ricevere il risultato via email è distinta dall’eventuale consenso al marketing.\n\nComunicazioni promozionali\nSoltanto se l’utente esprime uno specifico consenso facoltativo, l’indirizzo email potrà essere utilizzato da CALLEGARI SRL SOCIETÀ BENEFIT per inviare comunicazioni relative a Lacrime di Coccodrillo, comprese novità, eventi, esperienze, prodotti e iniziative promozionali.\nIl consenso al marketing non è necessario per utilizzare il questionario né per ricevere il risultato richiesto.\nIl consenso può essere revocato in qualsiasi momento.",
  },
  {
    title: "Basi giuridiche",
    body: "Il trattamento necessario a fornire all’utente l’esperienza e, quando richiesto, il relativo risultato viene effettuato sulla base della richiesta dell’utente e delle misure necessarie a dare seguito alla stessa, nei limiti applicabili ai sensi dell’art. 6 del GDPR.\nIl trattamento necessario alla sicurezza e al corretto funzionamento tecnico del servizio può essere effettuato sulla base del legittimo interesse del Titolare alla gestione e protezione del servizio, nel rispetto dei diritti e delle libertà degli interessati.\nIl trattamento dell’indirizzo email per finalità promozionali viene effettuato esclusivamente sulla base del consenso dell’interessato, salvo gli specifici casi eventualmente consentiti dalla normativa applicabile.",
  },
  {
    title: "Separazione tra questionario e contatti",
    body: "L’architettura dell’applicazione mantiene separati:\n— dati delle sessioni del questionario, comprendenti risposte, punteggi, risultato, provenienza e timestamp;\n— e dati dei contatti, comprendenti nome eventualmente fornito, email e stato del consenso.\nCALLEGARI SRL SOCIETÀ BENEFIT non utilizza il questionario per costruire un archivio nominativo che associ sistematicamente l’identità dell’utente alle singole risposte e ai relativi punteggi.\nQuando l’utente richiede l’invio del risultato via email, le informazioni strettamente necessarie possono essere trattate per effettuare l’invio richiesto, senza che ciò comporti l’associazione permanente dell’indirizzo email all’intero questionario nel database destinato ai contatti marketing.",
  },
  {
    title: "Processi decisionali automatizzati",
    body: "Il risultato dell’esperienza viene prodotto automaticamente mediante un sistema di punteggi e regole predefinite.\nTale elaborazione serve esclusivamente a individuare la fragranza proposta nell’ambito dell’esperienza e non produce effetti giuridici sull’utente né effetti analogamente significativi.\nIl sistema non effettua diagnosi né valutazioni mediche o psicologiche.",
  },
  {
    title: "Servizi e soggetti coinvolti",
    body: "Per il funzionamento tecnico dell’esperienza possono essere utilizzati fornitori di servizi che trattano dati per conto del Titolare o nell’ambito dei rispettivi servizi.\nIn particolare, allo stato attuale possono essere coinvolti:\n— Emergent, per hosting dell’applicazione, infrastruttura tecnica e database di produzione;\n— MongoDB Atlas, per l’infrastruttura database utilizzata in produzione;\n— Resend, per l’invio delle email richieste dagli utenti.\nL’applicazione non utilizza attualmente Google Analytics, Meta Pixel o altri strumenti pubblicitari di profilazione.\nI caratteri tipografici utilizzati dall’applicazione sono ospitati localmente e non richiedono collegamenti a Google Fonts durante l’utilizzo del questionario.\nLe immagini dell’esperienza sono ospitate localmente nell’applicazione.",
  },
  {
    title: "Trasferimenti di dati al di fuori dello Spazio Economico Europeo",
    body: "Alcuni dei fornitori tecnici utilizzati possono comportare il trattamento di dati al di fuori dello Spazio Economico Europeo, inclusi gli Stati Uniti e, per alcuni servizi infrastrutturali, altri Paesi.\nQuando richiesto dalla normativa, tali trasferimenti devono avvenire sulla base di uno dei meccanismi previsti dal Capo V del GDPR, quali una decisione di adeguatezza, le Clausole Contrattuali Standard approvate dalla Commissione europea o altre garanzie previste dalla normativa applicabile.\nIl Titolare sta completando con i fornitori interessati la verifica delle condizioni contrattuali e delle garanzie applicabili alla specifica infrastruttura utilizzata dall’applicazione.\nPer informazioni relative ai trasferimenti internazionali è possibile contattare il Titolare agli indirizzi indicati nella presente informativa.",
  },
  {
    title: "Cookie e tecnologie di tracciamento",
    body: "Il questionario non utilizza attualmente cookie pubblicitari o di profilazione e non utilizza Google Analytics, Meta Pixel o strumenti analoghi.\nL’applicazione non utilizza cookie per identificare gli utenti che compilano il questionario.\nPer l’accesso all’area amministrativa riservata possono essere utilizzati strumenti tecnici di sessione necessari all’autenticazione dell’amministratore. Tali strumenti non riguardano gli utenti che compilano il questionario.\nQualora in futuro venissero introdotti strumenti che richiedano il consenso dell’utente, questa informativa e le modalità di gestione del consenso verranno aggiornate prima della loro attivazione.",
  },
  {
    title: "Conservazione dei dati",
    body: "I dati relativi alle sessioni del questionario e le informazioni necessarie alle finalità statistiche del progetto possono essere conservati per un periodo massimo di 5 anni, salvo necessità di ulteriore conservazione in forma anonima o aggregata.\nI dati utilizzati per l’invio del risultato vengono conservati per il tempo necessario alla gestione della richiesta e secondo le modalità tecniche del servizio utilizzato.\nI dati trattati per finalità di marketing vengono conservati fino alla revoca del consenso e comunque sottoposti a verifiche periodiche sulla necessità e proporzionalità della loro conservazione.\nI fornitori tecnici possono inoltre conservare log e copie di sicurezza per i periodi previsti dai rispettivi servizi e dalle esigenze di sicurezza e continuità operativa.",
  },
  {
    title: "Conferimento dei dati",
    body: "La compilazione del questionario non richiede la comunicazione di dati identificativi.\nLa comunicazione di nome ed email dopo la visualizzazione del risultato è facoltativa.\nIl mancato conferimento dell’email impedisce esclusivamente di ricevere tramite email il contenuto richiesto e non limita l’accesso al risultato all’interno dell’applicazione.\nIl mancato consenso al marketing non produce alcuna conseguenza sull’utilizzo dell’esperienza.",
  },
  {
    title: "Diritti dell’interessato",
    body: "Nei casi previsti dal GDPR, l’interessato può esercitare i propri diritti, tra cui:\n— ottenere conferma dell’esistenza o meno di dati personali che lo riguardano;\n— accedere ai propri dati;\n— richiederne la rettifica;\n— richiederne la cancellazione;\n— richiedere la limitazione del trattamento;\n— opporsi al trattamento nei casi previsti;\n— richiedere la portabilità dei dati quando applicabile;\n— revocare in qualsiasi momento il consenso precedentemente espresso, senza pregiudicare la liceità del trattamento effettuato prima della revoca.\nLe richieste possono essere inviate a: ldc.lacrimedicoccodrillo@gmail.com oppure tramite PEC: callegarildc@pec.it\nL’interessato ha inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali qualora ritenga che il trattamento dei propri dati violi la normativa applicabile.",
  },
  {
    title: "Revoca del consenso marketing",
    body: "L’utente può revocare in qualsiasi momento il consenso alla ricezione di comunicazioni promozionali utilizzando il sistema di disiscrizione presente nelle comunicazioni, quando disponibile, oppure scrivendo a: ldc.lacrimedicoccodrillo@gmail.com\nLa revoca è gratuita e non incide sull’utilizzo del questionario.",
  },
  {
    title: "Sicurezza",
    body: "Sono adottate misure tecniche e organizzative finalizzate a proteggere i dati da accessi non autorizzati, perdita, divulgazione o modifica indebita.\nL’accesso alla dashboard amministrativa e ai dati raccolti è riservato ai soggetti autorizzati.",
  },
  {
    title: "Modifiche all’informativa",
    body: "La presente Privacy Policy potrà essere aggiornata in conseguenza di modifiche dell’esperienza, dei fornitori utilizzati o della normativa applicabile.\nLa versione aggiornata sarà resa disponibile all’interno dell’applicazione.",
  },
];
